import {
  TableCell, TableRow, Box, Collapse, Table, TableHead,
  styled, tableCellClasses, IconButton, TableBody, Accordion,
  AccordionSummary, Typography, ListItemText, Stack, List,
  ListItem, AccordionDetails, Divider, TablePagination,
  Grid
} from "@mui/material";
import { ChangeEvent, Dispatch, FC, SetStateAction, SyntheticEvent, useEffect, useState } from "react";
import { cellStyle } from "../Pays/RowPays";
import { AxiosInstance } from "axios";
import { ClientWithChildInterface, DeviseInterface } from "./InterfaceArticle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DataRef } from "../../../../types/DataRef";
import { DatasArticle, IUserRef, SecondNiveau } from "./Article";
import SecondNiveauArticle from "./SecondNiveauArticle";
import { IPays } from "../Pays/Pays";
import { AlertType } from "../../../../types/AlertType";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

interface RowArticleAtribute {
  isDesktopOrLaptop: boolean;
  row: DatasArticle;
  dataRefPaysBu: IPays[];
  alltype: DataRef[];
  allActivite: DataRef[];
  allDevise: DeviseInterface[];
  allClientWithChild: ClientWithChildInterface[];
  RereshDataArticle: () => void;
  http: AxiosInstance;
  reloadList: () => void;
  setOpenSnack: Dispatch<SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<SetStateAction<string>>;
  setAlertType: Dispatch<SetStateAction<AlertType>>;
  expanded: number | false;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  allUserGRCCommerciaux: IUserRef[];
}

const ArticleRow: FC<RowArticleAtribute> = ({
  isDesktopOrLaptop,
  row,
  dataRefPaysBu,
  alltype,
  allActivite,
  allDevise,
  allClientWithChild,
  RereshDataArticle,
  http,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList,
  expanded,
  setExpanded,
  allUserGRCCommerciaux
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [displayedItems, setDisplayedItems] = useState<SecondNiveau[]>([]);


  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    setDisplayedItems(row?.secondNiveau.slice(startIndex, endIndex));
  }, [page, rowsPerPage,row]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <>
          <TableRow>
            <TableCell align="center">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
                sx={{ color: "#fff", fontSize: 12 }}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            <TableCell style={cellStyle} align="center">
              {row?.firstNiveau?.societe_libelle}
            </TableCell>
            <TableCell style={cellStyle} align="center">
              {row?.firstNiveau?.code_gesco_libelle}
            </TableCell>
            <TableCell style={cellStyle} align="center">
              {row?.firstNiveau?.operation_libelle}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={cellStyle} colSpan={4}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell style={cellStyle} align="center">
                          Pays
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Business Unit
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Client
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Code articles
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Désignation
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Tarif Heures
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Tarif Actes
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Couts
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Action
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {displayedItems.map((article) => (
                        <SecondNiveauArticle
                          key={article?.id}
                          isDesktopOrLaptop={isDesktopOrLaptop}
                          RereshDataArticle={RereshDataArticle}
                          allActivite={allActivite}
                          allClientWithChild={allClientWithChild}
                          allDevise={allDevise}
                          alltype={alltype}
                          dataRefPaysBu={dataRefPaysBu}
                          http={http}
                          firstNiveau={row?.firstNiveau}
                          secondNiveau={article}
                          setAlertType={setAlertType}
                          setAlerteMessage={setAlerteMessage}
                          setOpenSnack={setOpenSnack}
                          allUserGRCCommerciaux={allUserGRCCommerciaux}
                        />
                      ))}
                    </TableBody>
                  </Table>
                  {row?.secondNiveau.length > rowsPerPage ? (
                    <TablePagination
                      component="div"
                      showFirstButton
                      showLastButton
                      colSpan={9}
                      page={page}
                      size="small"
                      align="center"
                      rowsPerPage={rowsPerPage}
                      count={row?.secondNiveau.length}
                      rowsPerPageOptions={[5, 10, 25]}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      labelRowsPerPage='Ligne par page :'
                      labelDisplayedRows={({ from, to, count }) => `${from} à ${to} sur ${count}`}
                      sx={{
                        color: '#fff',
                        '& .MuiTablePagination-selectIcon': {
                          color: '#fff',
                        },
                        /* '& .css-78trlr-MuiButtonBase-root-MuiIconButton-root': {
                          color: '#fff'
                        } */
                        '& .MuiSvgIcon-root': {
                          color: '#fff'
                        }
                      }}
                    />
                  ) : null}
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      ) : (
        <Accordion
          expanded={expanded === row?.firstNiveau?.pivot_oper_socifact_id}
          onChange={handleChangeAccordionValue(row?.firstNiveau?.pivot_oper_socifact_id)}
          sx={{
            borderRadius: 1,
            bgcolor: '#fff',
            mb: 1,
            ml: 0.1
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#080d24' }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Société facturation :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.firstNiveau?.societe_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Code gesco :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.firstNiveau?.code_gesco_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Opération :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.firstNiveau?.operation_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction='column' spacing={1}>
              <Box>
                <Typography gutterBottom variant="h5" component="div" sx={{ mb: 0 }}>
                  Ses articles
                </Typography>
                <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 1 }} />
              </Box>

              {row?.secondNiveau?.map((article) => (
                <SecondNiveauArticle
                  key={article?.id}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  RereshDataArticle={RereshDataArticle}
                  allActivite={allActivite}
                  allClientWithChild={allClientWithChild}
                  allDevise={allDevise}
                  alltype={alltype}
                  dataRefPaysBu={dataRefPaysBu}
                  http={http}
                  firstNiveau={row?.firstNiveau}
                  secondNiveau={article}
                  setAlertType={setAlertType}
                  setAlerteMessage={setAlerteMessage}
                  setOpenSnack={setOpenSnack}
                  allUserGRCCommerciaux={allUserGRCCommerciaux}
                />
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

export default ArticleRow;
